var map = {
	"./arrow-down-trigger.svg": 10792,
	"./arrow-down.svg": 54750,
	"./arrow-left-new.svg": 25944,
	"./arrow-left-v2.svg": 93047,
	"./arrow-left-v3.svg": 19207,
	"./arrow-right-old.svg": 81276,
	"./arrow-right-order.svg": 25936,
	"./arrow-right-v2.svg": 71446,
	"./arrow-right-v3.svg": 78144,
	"./arrow-right.svg": 18007,
	"./arrow-up.svg": 11069,
	"./ask.svg": 56599,
	"./check-mark.svg": 56115,
	"./check.svg": 82948,
	"./closed.svg": 2124,
	"./delete.svg": 74238,
	"./delivery-shop.svg": 53393,
	"./done.svg": 11174,
	"./edit.svg": 66380,
	"./icon-address.svg": 69672,
	"./icon-ads-plus.svg": 55240,
	"./icon-comment.svg": 96659,
	"./icon-fav.svg": 64714,
	"./icon-like.svg": 50606,
	"./icon-local.svg": 70722,
	"./icon-location.svg": 47345,
	"./icon-lottery.svg": 746,
	"./icon-menu-v2.svg": 14874,
	"./icon-menu-v3.svg": 11931,
	"./icon-menu.svg": 73393,
	"./icon-pk.svg": 47518,
	"./icon-return.svg": 24419,
	"./icon-share-v2.svg": 9889,
	"./icon-share.svg": 41204,
	"./icon-switch-light.svg": 29017,
	"./icon-switch.svg": 26098,
	"./icon-tui-kuan.svg": 17385,
	"./icon-x.svg": 97206,
	"./plus.svg": 70633,
	"./qa-ask.svg": 74432,
	"./qa-zan-active.svg": 84258,
	"./qa-zan.svg": 13892,
	"./search-gray.svg": 51717,
	"./search-v2.svg": 97518,
	"./search.svg": 45138,
	"./select-disable.svg": 61981,
	"./selected.svg": 40525,
	"./star.svg": 10690,
	"./triangle-down.svg": 57317,
	"./triangle-up.svg": 88237,
	"./unselected-v2.svg": 13790,
	"./unselected.svg": 73410
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87886;